import NewsCarouselSkeleton from "./elements/NewsCarouselSkeleton";
import PostsSectionSkeleton from "./elements/PostsSectionSkeleton";
import ResponsiveFeaturedSkeleton from "./elements/ResponsiveFeaturedSkeleton";

const HomeSkeleton = () => {
  return (
    <>
      {/* ✅ Skeleton for Carousel - Hidden on mobile */}
      <div className="hidden sm:block">
        <NewsCarouselSkeleton />
      </div>

      {/* ✅ Main Container (Correctly Structured) */}
      <div className="container mx-auto px-4 py-6">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {/* ✅ Main Section (2/3 width) */}
          <div className="space-y-6 md:col-span-2">
            <ResponsiveFeaturedSkeleton />
          </div>

          {/* ✅ Sidebar (1/3 width) */}
          <div className="flex flex-col space-y-6">
            {/* Posts Section (Hidden on mobile) */}
            <div className="hidden sm:block">
              <PostsSectionSkeleton />
            </div>
            <SkeletonBox height="h-56" />
          </div>
        </div>
      </div>

      {/* ✅ Featured News Section */}
      <div className="container mx-auto p-4">
        <SkeletonBox height="h-48" />
      </div>

      {/* ✅ Structured Sections (Ensuring Proper Alignment) */}
      <div className="container mx-auto grid grid-cols-1 gap-6 px-4 py-6 md:grid-cols-3">
        {/* ✅ Analysis Section (2/3 width) */}
        <div className="md:col-span-2">
          <SkeletonBox height="h-64" />
        </div>

        {/* ✅ Sidebar Widgets (Follow Us & Most Viewed) */}
        <div className="space-y-6">
          <SkeletonBox height="h-40" />
          <SkeletonBox height="h-40" />
        </div>
      </div>

      {/* ✅ General News Section */}
      <div className="container mx-auto p-4">
        <SkeletonBox height="h-72" />
      </div>

      {/* ✅ International News Section */}
      <div className="container mx-auto p-4">
        <SkeletonBox height="h-64" />
      </div>
    </>
  );
};

/* ✅ Reusable Skeleton Box Component */
const SkeletonBox = ({
  height,
  className = "",
}: {
  height: string;
  className?: string;
}) => (
  <div
    aria-hidden="true"
    className={`${height} w-full animate-pulse rounded-lg bg-gray-300 dark:bg-gray-700 ${className}`}
  ></div>
);

export default HomeSkeleton;
